module.exports = __webpack_public_path__ + "assets/img/lvban.50745180.png";